import { getSpecialOffer } from "../../../Admin/State/Offer/Action";
import { getProducts } from "../../../Admin/State/Product/Action";
import { privateAxios } from "../../../config/apiConfig";
import { getAllProduct } from "../Product/Action";
import {
  CREATE_OFFER_FAILURE,
  CREATE_OFFER_REQUEST,
  DELETE_OFFER_REQUEST,
  DELETE_OFFER_FAILURE,
  UPDATE_OFFER_REQUEST,
  UPDATE_OFFER_FAILURE,
  GET_ALL_PRODUCT_OFFER_REQUEST,
  GET_ALL_PRODUCT_OFFER_SUCCESS,
  GET_ALL_PRODUCT_OFFER_FAILURE,
  CREATE_OFFER_SUCCESS,
  UPDATE_OFFER_SUCCESS,
  DELETE_OFFER_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllProductOffer = () => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCT_OFFER_REQUEST })
  try {
    const { data } = await privateAxios.get(`admin/offers/product`);
    dispatch({ type: GET_ALL_PRODUCT_OFFER_SUCCESS, payload: data })
  } catch (error) {
    dispatch({ type: GET_ALL_PRODUCT_OFFER_FAILURE, payload: error.message })
  }
}

export const createOffer = (productId, offerData) => async (dispatch) => {
  dispatch({ type: CREATE_OFFER_REQUEST });
  try {
    const { data } = await privateAxios.post(`vendor/offer/product/${productId}`, offerData);
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts())
      dispatch({ type: CREATE_OFFER_SUCCESS, payload: data })
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_OFFER_FAILURE, payload: error.message });
  }
};

export const updateOffer = (offerId, offerData) => async (dispatch) => {
  dispatch({ type: UPDATE_OFFER_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `vendor/offer/${offerId}`,
      offerData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts())
      dispatch({ type: UPDATE_OFFER_SUCCESS, payload: data })
      toast.success("offer Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_OFFER_FAILURE, payload: error.message });
  }
};

export const deleteOffer = (offerId) => async (dispatch) => {
  dispatch({ type: DELETE_OFFER_REQUEST });
  try {
    const { data } = await privateAxios.delete(`vendor/offer/${offerId}`);
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getSpecialOffer())
      dispatch(getProducts())
      dispatch({ type: DELETE_OFFER_SUCCESS, payload: data })
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_OFFER_FAILURE, payload: error.message });
  }
};
